module.exports = __webpack_public_path__ + "static/media/CV01.abbd5050.jpg";